var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.accordionClasses},[_c('div',{on:{"click":_vm.toggleAccordion}},[_vm._t("header")],2),_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }